document.addEventListener("DOMContentLoaded", function() {
  const timeCounts = document.querySelectorAll("[data-countdown-time]");
  timeCounts.forEach(timeCount => {
    const endTime = new Date(timeCount.getAttribute("data-countdown-time")).getTime();
    
    function updateCountdown() {
      const now = new Date().getTime();
      const distance = endTime - now;

      if (distance <= 0) {
        timeCount.textContent = "00 day : 00 hr : 00 min";
        clearInterval(interval);
        return;
      }

      const days = String(Math.floor(distance / (1000 * 60 * 60 * 24))).padStart(2, '0');
      const hours = String(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0');
      const minutes = String(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0');
      const daysText = days < "02" ? `${days} day : ` : `${days} days : `;
      const hoursText = hours < "02" ? `${hours} hr : ` : `${hours} hrs : `;
      const minutesText = minutes < "02" ? `${minutes} min` : `${minutes} mins`;

      timeCount.textContent = `${daysText} ${hoursText} ${minutesText}`;
    }

    const interval = setInterval(updateCountdown, 1000);
    updateCountdown(); // Initial run
  });

  const toggleMore = document.querySelectorAll('[data-toggle-button]');
  toggleMore?.forEach(button => {
    button.addEventListener('click', () => {
      const id = button.getAttribute('data-toggle-button');
      if (!id) return;
      const itemParent = button.closest(`[data-block-type="${id}"]`);
      itemParent?.classList.toggle('is-expanded');
    });
  });

  // Cop product link to clipboard
  const copyBtn = document.getElementById("copyLinkBtn");
  const input = document.getElementById("shareLink");

  copyBtn?.addEventListener("click", function () {
    input.select();
    input.setSelectionRange(0, 99999); // for mobile
    navigator.clipboard.writeText(input.value).then(() => {
      copyBtn.textContent = "Copied!";
      setTimeout(() => (copyBtn.textContent = "Copy Link"), 2000);
    });
  });

  // Register continue button
  const registerContinueButton = document.querySelectorAll('[data-register-continue]');
  registerContinueButton.forEach(button => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      const formID = event.target.getAttribute("data-register-continue");
      if (!formID) return;
      document.querySelector(`[form="${formID}"] [type="submit"]`).click();
    });
  });

  // Card badge marquee - only animate if content exceeds container
  function checkBadgeOverflow(container) {
    const marquee = container.querySelector('.card-badge-marquee');
    if (!marquee) return;

    const duplicates = marquee.querySelectorAll('.card-badge[data-duplicate]');
    const duplicateElements = Array.from(duplicates);
    duplicateElements.forEach(dup => dup.remove());
    
    const containerWidth = container.offsetWidth;
    const originalMarqueeWidth = marquee.scrollWidth;
    
    if (originalMarqueeWidth > containerWidth) {
      container.classList.add('has-overflow');
      if (duplicateElements.length === 0) {
        const badges = marquee.querySelectorAll('.card-badge:not([data-duplicate])');
        badges.forEach(badge => {
          const clone = badge.cloneNode(true);
          clone.setAttribute('data-duplicate', 'true');
          marquee.appendChild(clone);
        });
      } else {
        duplicateElements.forEach(dup => marquee.appendChild(dup));
      }
    } else {
      container.classList.remove('has-overflow');
      duplicateElements.forEach(dup => dup.remove());
    }
  }

  function initCardBadgeMarquee() {
    const containers = document.querySelectorAll('.card-badge-container:not([data-marquee-initialized])');
    
    containers.forEach(container => {
      container.setAttribute('data-marquee-initialized', 'true');
      checkBadgeOverflow(container);
    });
  }

  initCardBadgeMarquee();
  
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const containers = document.querySelectorAll('.card-badge-container[data-marquee-initialized]');
      containers.forEach(container => checkBadgeOverflow(container));
    }, 150);
  });
  
  const observer = new MutationObserver((mutations) => {
    let hasNewContainers = false;
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          if (node.classList?.contains('card-badge-container')) {
            hasNewContainers = true;
          } else if (node.querySelector?.('.card-badge-container')) {
            hasNewContainers = true;
          }
        }
      });
    });
    if (hasNewContainers) {
      initCardBadgeMarquee();
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});